import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { RequestService } from 'app/core/services/request.service';
import { ConfigService } from 'app/core/services/config.service';
import {BuyerEmailDetails} from '../components/details/buyer-email-details.model';

@Injectable()
export class SolarEmailService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService
    ) {}

    getEmailDetails(id: string): Observable<BuyerEmailDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').tm.email.details.api + '/'+id;
        return this.requestService.get(url);
    }

    resend(id: String): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').tm.email.retry.api + '/'+id;
        return this.requestService.post(url, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/communication/emails/service/emails.service.ts